import { render, staticRenderFns } from "./PlayRankBars.vue?vue&type=template&id=61a74058&scoped=true"
import script from "./PlayRankBars.vue?vue&type=script&lang=js"
export * from "./PlayRankBars.vue?vue&type=script&lang=js"
import style0 from "./PlayRankBars.vue?vue&type=style&index=0&id=61a74058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a74058",
  null
  
)

export default component.exports